export type TIsAddressValidOptions = {
  checkGoogleValidated?: null | boolean;
  checkMissingInfo?: null | boolean;
};

export const isAddressValid = (address?: null | Record<string, any>, options?: TIsAddressValidOptions) => {
  if (!address) return false;
  const { address1, city, state, country, zipCode, addressFromGoogle, useGoogleAddress, googleValidated, missingInfo } = address;
  const isBaseAddressComplete = address1 && city && state && country && zipCode;
  const isGoogleAddressComplete = addressFromGoogle?.address1 && addressFromGoogle?.city && addressFromGoogle?.state && addressFromGoogle?.country && addressFromGoogle?.zipCode;
  //console.log('address:', address);
  //console.log('isBaseAddressComplete:', isBaseAddressComplete);
  //console.log('useGoogleAddress:', useGoogleAddress);
  //console.log('isGoogleAddressComplete:', isGoogleAddressComplete);
  let isAddressComplete = isBaseAddressComplete || (useGoogleAddress && isGoogleAddressComplete);
  if (options?.checkGoogleValidated) isAddressComplete = isAddressComplete && googleValidated;
  if (options?.checkMissingInfo) isAddressComplete = isAddressComplete && missingInfo;
  return isAddressComplete;
};
